const headerData = [
    {
        key: "HomeAbout",
        title: "Home & About",
        href: "/",
        navigation: "HomeAbout"
    },
    {
        key: "EducationWork",
        title: "Education & Work Experience",
        href: "/EducationWork.html",
        navigation: "EducationWork"
    },
    {
        key: "SkillProject",
        title: "Skills & Projects",
        href: "/SkillProject.html",
        navigation: "SkillProject"
    },
    {
        key: "HobbyInterest",
        title: "Hobbies & Interests",
        href: "/HobbyInterest.html",
        navigation: "HobbyInterest"
    },
    {
        key: "ContactMe",
        title: "Contact Me",
        href: "/ContactMe.html",
        navigation: "ContactMe"
    }
];

export default headerData;